import { E_Route } from "@repo-sapiens/constants";

export const useDemoMode = () => {
  const activateDemoMode = () => {
    localStorage.setItem("demoMode", "true");
  };
  const deactivateDemoMode = (noRedirect?: boolean) => {
    localStorage.removeItem("demoMode");
    if (!noRedirect) {
      window.location.href = E_Route.Onboarding;
    }
  };
  const demoMode = localStorage.getItem("demoMode") === "true";
  return {
    demoMode,
    activateDemoMode,
    deactivateDemoMode,
  };
};
